app.controller('AppController', ['$scope', '$window', '$http', '$templateCache', 'bezoeker', 'globals', function($scope, $window, $http, $templateCache, bezoeker, globals) {
	$scope.bezoeker = bezoeker;
	$scope.globals = globals;

	/* SAVE THE USER EACH TIME A PROPERTY CHANGES */
	$scope.$watchCollection('bezoeker', function() {

		if(bezoeker.gewenstLeenbedrag > globals.maxBedragTotaal)
			bezoeker.gewenstLeenbedrag = globals.maxBedragTotaal;

		bezoeker.store(false);
	});


	/* DEFAULT FORM SUBMISSION / VALIDATION CODE */
	$scope.onSubmit = function(formName, e){

		e.preventDefault();

		var form = angular.element('form#'+e.target.form.id);

        $scope[formName].dirtyCheck.$setViewValue($scope[formName].dirtyCheck.$viewValue);

        if($scope[formName].$valid)
        {
            form.submit();
        }else{
            form.find('.ng-invalid:first').focus();
        }
	};

}]);